// extracted by mini-css-extract-plugin
export default {"products":"xC-z","card":"yC-z","oosMessaging":"zC-z"};